// extracted by mini-css-extract-plugin
export default {"customPlanHeader":"HeaderSharedStyles_customPlanHeader__5mswq","deleteCustomPlanButton":"HeaderSharedStyles_deleteCustomPlanButton__a5whX"};